(function () {
  const locale = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  const path = window.location.pathname || '';
  if (!locale.startsWith('en') && !path.startsWith('/en/')) return;

  const labels = {
    '15/18': 'UK 0-2',
    '19/22': 'UK 3-5.5',
    '23/26': 'UK 6-8.5',
    '27/30': 'UK 9-12',
    '31/35': 'UK 12.5-2.5',
    '36/41': 'UK 4-7',
    '42/46': 'UK 8-11',
    '43/46': 'UK 9-11',
    '47/50': 'UK 12-14',
    '1/3': 'UK 1-3',
    '4/7': 'UK 4-7',
    '8/11': 'UK 8-11',
    'k0/2': 'Kids UK 0-2',
    'k3/5': 'Kids UK 3-5',
    'k6/8': 'Kids UK 6-8',
    'k9/11': 'Kids UK 9-11'
  };
  const singleSizeLabels = {
    '30': 'Kids UK 11.5',
    '31': 'Kids UK 12.5',
    '32': 'Kids UK 13',
    '33': 'UK 1',
    '34': 'UK 2',
    '35': 'UK 2.5',
    '36': 'UK 3.5',
    '37': 'UK 4',
    '38': 'UK 5',
    '39': 'UK 6',
    '40': 'UK 6.5',
    '41': 'UK 7',
    '42': 'UK 8',
    '43': 'UK 9',
    '44': 'UK 9.5',
    '45': 'UK 10.5',
    '46': 'UK 11',
    '47': 'UK 12',
    '48': 'UK 13',
    '49': 'UK 14',
    '50': 'UK 14.5'
  };

  const broadPattern = /(15\s*[/-]\s*18|19\s*[/-]\s*22|23\s*[/-]\s*26|27\s*[/-]\s*30|31\s*[/-]\s*35|36\s*[/-]\s*41|42\s*[/-]\s*46|43\s*[/-]\s*46|47\s*[/-]\s*50)/gi;
  const scopedPattern = /(1\s*[/-]\s*3|4\s*[/-]\s*7|8\s*[/-]\s*11|k0\s*[/-]\s*2|k3\s*[/-]\s*5|k6\s*[/-]\s*8|k9\s*[/-]\s*11)/gi;
  const scopedSelector = [
    '#gbbBundle',
    '.gbbProductVariantModalContainer',
    'variant-selects',
    'variant-radios',
    '.product-form__input',
    '.arch-variants',
    '.arch-variants-outer',
    '.facets',
    '.mobile-facets',
    '.active-facets',
    '.ac-filterbar',
    '.card-wrapper',
    '.fcs-card',
    '.cart-drawer',
    '.cart-items',
    '.cart-notification',
    '.product-option',
    '.pickup-availability-variant'
  ].join(',');
  const ignoredSelector = 'script,style,template,noscript,textarea';
  const attributeNames = ['aria-label', 'title'];
  const ukRepeatedPattern = /\b(?:UK\s+){2,}(0-2|3-5\.5|6-8\.5|9-12|12\.5-2\.5|4-7|8-11|9-11|12-14|1-3|3-5|6-8)\b/gi;
  const kidsUkRepeatedPattern = /\bKids\s+(?:UK\s+){2,}(0-2|3-5|6-8|9-11)\b/gi;
  let scheduled = false;

  function normalizeSize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '').replace(/-/g, '/');
  }

  function replaceText(text, scoped) {
    if (!text) return text;

    const replaceSize = (match, offset, source) => {
      const prefix = source.slice(Math.max(0, offset - 12), offset);
      if (/(?:Kids\s+)?UK\s*$/i.test(prefix)) return match;
      return labels[normalizeSize(match)] || match;
    };
    const replacePattern = (value, pattern) => value.replace(pattern, (match, ...args) => {
      const offset = args[args.length - 2];
      const source = args[args.length - 1];
      return replaceSize(match, offset, source);
    });

    let next = replacePattern(text, broadPattern);
    if (scoped) {
      next = replacePattern(next, scopedPattern);
      const exactSize = next.trim();
      if (singleSizeLabels[exactSize]) {
        next = next.replace(exactSize, singleSizeLabels[exactSize]);
      }
    }
    next = next
      .replace(kidsUkRepeatedPattern, 'Kids UK $1')
      .replace(ukRepeatedPattern, 'UK $1');
    return next;
  }

  function isScoped(node) {
    const element = node.nodeType === 1 ? node : node.parentElement;
    return Boolean(element && element.closest(scopedSelector));
  }

  function shouldSkip(node) {
    const element = node.nodeType === 1 ? node : node.parentElement;
    return Boolean(!element || element.closest(ignoredSelector));
  }

  function syncText(root) {
    if (!root || shouldSkip(root)) return;
    const walkerRoot = root.nodeType === 3 ? root.parentElement : root;
    if (!walkerRoot) return;

    if (root.nodeType === 3) {
      const next = replaceText(root.nodeValue, isScoped(root));
      if (next !== root.nodeValue) root.nodeValue = next;
      return;
    }

    const walker = document.createTreeWalker(walkerRoot, 4, {
      acceptNode(node) {
        return shouldSkip(node) ? 2 : 1;
      }
    });
    let node = walker.nextNode();
    while (node) {
      const next = replaceText(node.nodeValue, isScoped(node));
      if (next !== node.nodeValue) node.nodeValue = next;
      node = walker.nextNode();
    }
  }

  function syncAttributes(root) {
    if (!root || root.nodeType !== 1 || shouldSkip(root)) return;

    const elements = [root].concat(Array.from(root.querySelectorAll ? root.querySelectorAll('[aria-label],[title]') : []));
    elements.forEach((element) => {
      const scoped = isScoped(element);
      attributeNames.forEach((name) => {
        const value = element.getAttribute(name);
        if (!value) return;
        const next = replaceText(value, scoped);
        if (next !== value) element.setAttribute(name, next);
      });
    });
  }

  function sync(root) {
    const target = root || document.body;
    if (!target) return;
    syncText(target);
    syncAttributes(target);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      sync(document.body);
    });
  }

  function start() {
    sync(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          schedule();
          return;
        }
        if (mutation.addedNodes.length) schedule();
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
